import { HttpParams } from '@angular/common/http';
import { User } from '../../core/models/user.model';

const TRAINING_REQUEST_BASE_URL = 'https://salesintel.io/training-request';

export function buildTrainingRequestUrl(user?: User): string {
    const params = new HttpParams()
        .set('firstname', user?.first_name || '')
        .set('lastname', user?.last_name || '')
        .set('email', user?.email || '')
        .set('si_acct_id_hs_only', user?.account_id?.toString() ?? '')
        .set('si_acct_name_hs_only', user?.account_name ?? '');

    return `${TRAINING_REQUEST_BASE_URL}?${params.toString()}`;
}
